import React from "react";
import useAuthStore from "../stores/useAuthStore";

const PageTitle = ({ title, sub, icon, showDivider = true }) => {
  const { user } = useAuthStore();

  const displayTitle = title || `Welcome ${user?.firstname || "Student"}`;
  const displaySub = sub || "Your student dashboard";

  React.useEffect(() => {
    document.title = `ATBCOE Kangere | ${displayTitle}`;
  }, [displayTitle]);

  return (
    <div className="px-5 py-3 mb-4 bg-white">
      <h1 className="text-2xl font-bold text-neutral-800 m-0 mb-2 flex items-center gap-3">
        {icon && <span>{icon}</span>}
        {displayTitle}
      </h1>
      <p className="text-neutral-500 text-sm m-0">{displaySub}</p>
      {showDivider && <hr className="border-none border-t border-neutral-200 mt-4 mb-0" />}
    </div>
  );
};

export default PageTitle;
